import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ChartContainer } from '../ChartContainer';
import styles from '../../dashboard/Dashboard.module.scss';

const CHART_HEIGHT = 320;

export type AttendanceChartPoint = {
  month: string;
  attendance: number;
  engagement: number;
};

interface AttendanceEngagementChartProps {
  data?: AttendanceChartPoint[];
}

export const AttendanceEngagementChart = ({ data = [] }: AttendanceEngagementChartProps) => (
  <div>
    <div className={styles.chartLegend}>
      <span>
        <span className={styles.legendDot} style={{ background: '#0068D6' }} />
        Attendance
      </span>
      <span>
        <span className={styles.legendDot} style={{ background: '#1E7E34' }} />
        Engagement
      </span>
    </div>
    <ChartContainer height={CHART_HEIGHT}>
      <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
        <BarChart data={data} barGap={4} barCategoryGap="20%">
          <CartesianGrid stroke="#f0f0f0" vertical={false} />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#8f8f8f', fontSize: 12 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#8f8f8f', fontSize: 12 }}
            tickFormatter={(v) => `${v}%`}
            domain={[0, 100]}
          />
          <Tooltip
            cursor={{ fill: 'rgba(0,0,0,0.04)' }}
            content={({ active, payload, label }) => {
              if (!active || !payload?.length) return null;
              return (
                <div className="rounded-lg bg-[#1E1E1E] px-3 py-2 text-sm text-white shadow-lg">
                  <p className="mb-1 font-semibold">{label}</p>
                  {payload.map((item) => (
                    <p key={item.name} className="flex items-center gap-2">
                      <span
                        className="inline-block h-2 w-2 rounded-full"
                        style={{ background: item.color }}
                      />
                      {item.value}% {item.name}
                    </p>
                  ))}
                </div>
              );
            }}
          />
          <Bar
            dataKey="attendance"
            name="Attendance"
            fill="#0068D6"
            radius={[4, 4, 0, 0]}
            maxBarSize={28}
          />
          <Bar
            dataKey="engagement"
            name="Engagement"
            fill="#1E7E34"
            radius={[4, 4, 0, 0]}
            maxBarSize={28}
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  </div>
);
